import { Subject } from 'rxjs';

const subject = new Subject();

export default {
  clearHtml: () => subject.next({ action: 'clearHtml' }),
  getHtml: () => subject.asObservable(),
  onHtmlReady: (data) => subject.next({ action: 'onHtmlReady', ...data }),
  onHtmlRemoved: (data) => subject.next({ action: 'onHtmlRemoved', ...data }),
  setHtml: (data) => subject.next({ action: 'setHtml', value: data.payload }),
  setPreviousHtml: () => subject.next({ action: 'setPreviousHtml' }),
};
